export default __webpack_public_path__ + "static/media/img8.e8a721bf.jpg";